import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { AnalyticsEntitiesModule } from '@epicuro-next/state/analytics-entities';
import { ListEntitiesModule } from '@epicuro-next/state/list-entities';
import { UserStateModule } from '@epicuro-next/state/user-state';

import { HotListIndicatorComponent } from './hot-list-indicator.component';

@NgModule({
  imports: [
    CommonModule,
    TooltipDirective,
    IconsModule,
    AnalyticsEntitiesModule,
    ListEntitiesModule,
    UserStateModule,
  ],
  declarations: [HotListIndicatorComponent],
  exports: [HotListIndicatorComponent],
})
export class HotListIndicatorModule {}
